import { serviceRoutes, getBlob } from './index';

export const descargarDocumento = async ({ fileName }) =>
  await getBlob(serviceRoutes.descargarDocumentoS3, `?fileName=${encodeURIComponent(fileName)}`);
